import { createContext, useContext } from "react";
import { isErroCode } from "@/shared/lib/api/errors";

export type ValorConsentimentoIa = {
  /**
   * Antes de enviar algo a IA: true se a pessoa ja aceitou ou aceitou agora;
   * false com "Agora nao" (nada e enviado).
   */
  garantir: () => Promise<boolean>;
  /** A permissao foi retirada (perfil ou 403 da API): a proxima vez pergunta. */
  esquecer: () => void;
};

export const ContextoConsentimentoIa =
  createContext<ValorConsentimentoIa | null>(null);

const SEM_PROVEDOR: ValorConsentimentoIa = {
  garantir: async () => true,
  esquecer: () => {},
};

/**
 * Fora do provedor (testes de componente) devolve "aceito": quem barra de fato
 * e a API, com 403 CONSENTIMENTO_IA_PENDENTE.
 */
export function useConsentimentoIa(): ValorConsentimentoIa {
  return useContext(ContextoConsentimentoIa) ?? SEM_PROVEDOR;
}

export function ehConsentimentoIaPendente(err: unknown): boolean {
  return isErroCode(err, "CONSENTIMENTO_IA_PENDENTE");
}
